<template>
    <div class="shop-container">
        <div class="notice accent">{{ $t('deposit and withdraw through agencies, no commission!') | capitalize }}</div>
        <div class="notice">
            {{ $t('Deposit in the agency and you will have your money in your account instantly and' +
                ' at no commission! You can only withdraw from the agency if the deposit method was' +
                ' through the agency') | capitalize }}
        </div>
        <div>
            <SubtleLink :link="links.shops">
                {{ $t('find the nearest shop') | capitalize }}
            </SubtleLink>
        </div>
        <div>
            <SubtleLinkExternal :link="staticlink($t('payment-method-agency'))">
                {{ $t('details about agency deposits') | capitalize }}
            </SubtleLinkExternal>
        </div>
    </div>
</template>

<script>
    import { links } from '@app/router';
    import { staticlink } from '@shared/filters';

    export default {
        name: 'Shop',
        created() {
            this.staticlink = staticlink;
            this.links = links;
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/userProfile/deposit/AccordionItems/Shop.vue